import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Link } from 'foundations-components/transitional/components/Link';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { DEFAULT, OWNERSHIP_CHECK_FAILED } from '../constants/ErrorCauses';
import { SCREENS } from '../constants/tracking/Screens';
import { Metrics } from '../utils/metrics';
import { trackClickedLink, trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorPage({
  errorCause = DEFAULT,
  additionalErrorLogging = {}
}) {
  useEffect(() => {
    console.error(`ErrorPage visited with error cause: ${errorCause}`);
    trackPageView({
      screen: SCREENS.ERROR
    });
    Metrics.counter('error-page-visited', {
      errorType: errorCause
    }).increment();
    Raven.captureMessage(`ErrorPage visited with error cause: ${errorCause}`, {
      extra: additionalErrorLogging
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const titleKey = findValidI18nKey([`pricingPage.pages.errorPage.${errorCause}.title`, `pricingPage.pages.errorPage.default.title`]);
  const paragraphKey = findValidI18nKey([`pricingPage.pages.errorPage.${errorCause}.paragraph_jsx`, `pricingPage.pages.errorPage.default.paragraph_jsx`]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "1000",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ERROR_PAGE"
    }), /*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      height: 200,
      marginBlock: "1000"
    }), /*#__PURE__*/_jsx(H4, {
      marginBlockStart: "600",
      children: titleKey && /*#__PURE__*/_jsx(FormattedMessage, {
        message: titleKey
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "1000",
      children: paragraphKey && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: paragraphKey,
        elements: {
          UILink: Link
        },
        options: {
          onClick: () => {
            if (errorCause === OWNERSHIP_CHECK_FAILED) {
              trackClickedLink({
                name: 'contact-support-page',
                type: 'external',
                url: `${window.location.href}`
              });
            }
          }
        }
      })
    })]
  });
}
export default ErrorPage;